import { render, staticRenderFns } from "./SettingsFencesEU.vue?vue&type=template&id=f33b87b8&scoped=true"
import script from "./SettingsFencesEU.vue?vue&type=script&lang=js"
export * from "./SettingsFencesEU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33b87b8",
  null
  
)

export default component.exports